var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66699C5.40002 1.66699 1.66669 5.40033 1.66669 10.0003C1.66669 14.6003 5.40002 18.3337 10 18.3337C14.6 18.3337 18.3334 14.6003 18.3334 10.0003C18.3334 5.40033 14.6 1.66699 10 1.66699ZM10 14.167C9.54169 14.167 9.16669 13.792 9.16669 13.3337V10.0003C9.16669 9.54199 9.54169 9.16699 10 9.16699C10.4584 9.16699 10.8334 9.54199 10.8334 10.0003V13.3337C10.8334 13.792 10.4584 14.167 10 14.167ZM10.8334 7.50033H9.16669V5.83366H10.8334V7.50033Z",
    fill: "#6271DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.beeb1df742d6590b7ae5ae37a7879d13.svg";
export { ForwardRef as ReactComponent };